export default __webpack_public_path__ + "static/media/LoConnected.77c926f8.png";